export default () => {
	const timestamp = Date.now();
	const clickPath = JSON.parse(
		sessionStorage.getItem('ws-tracking-clickpath') || '{}'
	);
	clickPath[timestamp] = {
		path: window.location.href,
		viewType: window.DDC.dataLayer.page.pageInfo.pageName.match(
			'(?:^AUTO_.*_DETAILS|.*_DETAILS.*)$'
		)
			? 'vdp'
			: 'page',
		timestamp
	};
	sessionStorage.setItem('ws-tracking-clickpath', JSON.stringify(clickPath));
	return timestamp;
};
